import React, { useState } from 'react';
import { useEffect } from 'react';
import {
  Button,
  Form,
  Header,
  Input,
  Label,
  Segment,
  Select,
  TextArea,
} from 'semantic-ui-react';
import { movementOptions } from '../../../../app/common/options/movementOptions/movementOptions';
import { movementReasonOptions } from '../../../../app/common/options/movementOptions/movementReasonOptions';
import { movementTypeOptions } from '../../../../app/common/options/movementOptions/movementTypeOptions';
import { purposeOptions } from '../../../../app/common/options/inwardoutwardOptions/purposeOptions';
import { useStore } from '../../../../app/stores/store';
import { paymentModeOptions } from '../../../../app/common/options/inwardoutwardOptions/paymentModeOptions';
import {
  DeliveryRequest,
  DeliveryRequestInitialState,
} from '../../../../app/models/deliveryRequest';
import { observer } from 'mobx-react-lite';

import LoadingComponent from './../../../../app/layout/LoadingComponent';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import {
  OrderRegisterPayLoadType,
  circuitCreationPOST,
  hfcOutwardRegisterPayload,
} from '../../../../app/api/types';
import agent from '../../../../app/api/agent';

function OrderRegisterForm() {
  const {
    dashboardStore,
    activityStore,
    DeliveryStore,
    commonStore,
    userStore: { user },
  } = useStore();
  const { deleteOrderRegister, listOrderRegister, circuitCreation } =
    DeliveryStore;
  const { selectedDelivery, orderRegisterTrigger } = activityStore;

  const [orderRegister, SetOrderRegister] = useState<DeliveryRequest>(
    DeliveryRequestInitialState,
  );
  //for date reference
  const [registerOldDate, setRegisterOldDate] = useState('');
  //errors
  const [deliveryDateError, setDeliveryDateError] = useState(false);
  const [returnDateError, setReturnDateError] = useState(false);
  const [greaterDate, setGreaterDate] = useState<{
    delivery: boolean;
    play: boolean;
  }>({ delivery: false, play: false });
  const [movementToError, setMovementError] = useState(false);
  const [movementReasonError, setMovementReasonError] = useState(false);
  const [movementTypeError, setMovementTypeError] = useState(false);
  const [modeOfPaymentError, setModeOfPaymentError] = useState(false);
  const [purposeError, setPurposeError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [hfcMovementTo, setHfcMovementTo] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [hfcInfo, setHfcInfo] = useState<{
    address: string;
    fedexAccount: string;
  }>({
    address: '',
    fedexAccount: '',
  });
  const [hfcDateInfo, setHfcDateInfo] = useState<{ from: string; to: string }>({
    from: '',
    to: '',
  });

  useEffect(() => {
    (async () => {
      if (commonStore.hfcCustomerChanges) {
        const response = await agent.WorkLevels.getMasterColumn({
          masterName: 'Theatre',
          componentName: 'Theatre Name',
          filterColumn: '',
          filterValue: '',
        });
        const tempOptions = response.data?.map((tName) => {
          return {
            key: tName,
            value: tName,
            text: tName,
          };
        });
        setHfcMovementTo(tempOptions);
      }
    })();
    // eslint-disable-next-line
  }, [user?.customerName]);

  useEffect(() => {
    (async () => {
      if (commonStore.hfcCustomerChanges) {
        if (orderRegister.movementTo !== '') {
          const [addrRes, accRes] = await Promise.all([
            await agent.WorkLevels.getMasterColumn({
              masterName: 'Theatre',
              componentName: 'Address',
              filterColumn: 'Theatre Name',
              filterValue: orderRegister.movementTo,
            }),
            await agent.WorkLevels.getMasterColumn({
              masterName: 'Theatre',
              componentName: 'Fedex Account',
              filterColumn: 'Theatre Name',
              filterValue: orderRegister.movementTo,
            }),
          ]);
          setHfcInfo({
            address: addrRes.data[0],
            fedexAccount: accRes.data[0],
          });
        } else {
          setHfcInfo({
            address: '',
            fedexAccount: '',
          });
        }
      }
    })();
  }, [orderRegister.movementTo, commonStore.hfcCustomerChanges]);

  useEffect(() => {
    if (selectedDelivery !== undefined) {
      if (selectedDelivery) {
        const ActivityArr = selectedDelivery?.itemDeliveryRequest?.filter(
          (i) => i.isActive === true,
        )?.[0];
        const getDate = ActivityArr?.dateRequestRaised.slice(0, 10).split('-'); //create an array
        const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
        const newArr = {
          ...orderRegister,
          id: ActivityArr?.id,
          itemGroupId: ActivityArr?.itemGroupId,
          element: ActivityArr?.element,
          itemId: ActivityArr?.itemId,
          numberOfElement: ActivityArr?.numberOfElement,
          dateRequestRaised: _date,
          borrowerName: ActivityArr?.borrowerName,
          borrowerAddress: ActivityArr?.borrowerAddress,
          borrowerCode: ActivityArr?.borrowerCode,
          borrowerPhoneNumber: ActivityArr?.borrowerPhoneNumber,
          borrowerEmail: ActivityArr?.borrowerEmail,
          purpose: ActivityArr?.purpose,
          assetName: ActivityArr?.assetName,
          isActive: ActivityArr?.isActive,
        };
        SetOrderRegister(newArr);
        setRegisterOldDate(ActivityArr?.dateRequestRaised);
      }
      dashboardStore.dashboard.deliveryOrderTableClicked = false;
    }
    // eslint-disable-next-line
  }, [selectedDelivery]);

  const handleDateChange = (e: any) => {
    if (e.target.name === 'dateOfReturn') {
      if (orderRegister.dateOfDelivery < e.target.value) {
        const newArr = {
          ...orderRegister,
          [e.target.name]: e.target.value,
        };
        SetOrderRegister(newArr);
        setGreaterDate({
          ...greaterDate,
          delivery: false,
        });
      } else {
        setGreaterDate({
          ...greaterDate,
          delivery: true,
        });
      }
    } else if (e.target.name === 'dateOfDelivery') {
      if (
        orderRegister.dateOfReturn !== '' &&
        orderRegister.dateOfReturn < e.target.value
      ) {
        setGreaterDate({
          ...greaterDate,
          delivery: true,
        });
      } else {
        const newArr = {
          ...orderRegister,
          [e.target.name]: e.target.value,
        };
        SetOrderRegister(newArr);
        setGreaterDate({
          ...greaterDate,
          delivery: false,
        });
      }
    }
    if (e.target.name === 'from') {
      if (hfcDateInfo.to !== '' && hfcDateInfo.to < e.target.value) {
        setGreaterDate({
          ...greaterDate,
          play: true,
        });
      } else {
        const newArr = {
          ...hfcDateInfo,
          [e.target.name]: e.target.value,
        };
        setHfcDateInfo(newArr);
        setGreaterDate({
          ...greaterDate,
          play: false,
        });
      }
    } else if (e.target.name === 'to') {
      if (hfcDateInfo.from < e.target.value) {
        const newArr = {
          ...hfcDateInfo,
          [e.target.name]: e.target.value,
        };
        setHfcDateInfo(newArr);
        setGreaterDate({
          ...greaterDate,
          play: false,
        });
      } else {
        setGreaterDate({
          ...greaterDate,
          play: true,
        });
      }
    } else {
      const newArr = {
        ...orderRegister,
        isActive: false,
        [e.target.name]: e.target.value,
      };
      SetOrderRegister(newArr);
    }
  };
  const handleSelectChange = (e: any, data: any) => {
    const newArr = {
      ...orderRegister,
      dateOrderRegistered: new Date().toISOString(),
      isActive: false,
      [data.name]: data.value,
    };
    SetOrderRegister(newArr);
  };
  const handleSubmit = () => {
    let purposeErrors = true;
    let amountErrors = true;
    let modeOfPaymentErrors = true;
    let movementTypeErrors = true;
    let movementReasonErrors = true;
    let movementToErrors = true;
    let returnDateErrors = true;
    let deliveryDateErrors = true;
    /////////////////////////handling validation
    if (orderRegister.dateOfDelivery === '') {
      setDeliveryDateError(true);
    } else {
      setDeliveryDateError(false);
      deliveryDateErrors = false;
    }
    if (orderRegister.dateOfReturn === '') {
      setReturnDateError(true);
    } else {
      setReturnDateError(false);
      returnDateErrors = false;
    }
    if (orderRegister.movementTo === '') {
      setMovementError(true);
    } else {
      setMovementError(false);
      movementToErrors = false;
    }
    if (orderRegister.movementReason === '') {
      setMovementReasonError(true);
    } else {
      setMovementReasonError(false);
      movementReasonErrors = false;
    }
    if (orderRegister.movementType === '') {
      setMovementTypeError(true);
    } else {
      setMovementTypeError(false);
      movementTypeErrors = false;
    }
    if (orderRegister.modeOfPayment === '') {
      setModeOfPaymentError(true);
    } else {
      setModeOfPaymentError(false);
      modeOfPaymentErrors = false;
    }
    if (orderRegister.amount === '') {
      setAmountError(true);
      // setErrors(true);
    } else {
      setAmountError(false);
      amountErrors = false;
    }
    if (orderRegister.purpose === '') {
      setPurposeError(true);
    } else {
      setPurposeError(false);
      purposeErrors = false;
    }
    if (
      !purposeErrors &&
      !amountErrors &&
      !modeOfPaymentErrors &&
      !movementTypeErrors &&
      !movementReasonErrors &&
      !movementToErrors &&
      !returnDateErrors &&
      !deliveryDateErrors
    ) {
      handleFinalSubmit();
    }
  };

  const formatDate = (myDate: string, splitBy: string) => {
    const chunks = myDate.split('-');
    return chunks.reverse().join(splitBy);
  };

  const handleHFCSubmit = async (id: string, title: string) => {
    const metaDataSavePayload: hfcOutwardRegisterPayload = {
      id: id,
      theater: orderRegister.movementTo,
      location: hfcInfo.address,
      account: hfcInfo.fedexAccount,
      amount: orderRegister.amount,
      from: formatDate(hfcDateInfo.from, '/'),
      to: formatDate(hfcDateInfo.to, '/'),
      returnDate: formatDate(orderRegister.dateOfReturn, '/'),
    };
    const circuitPayload: circuitCreationPOST = {
      theater: orderRegister.movementTo,
      address: hfcInfo.address,
      deliveryDate: orderRegister.dateOfDelivery,
      returnDate: orderRegister.dateOfReturn,
    };
    await Promise.all([
      agent.HFC.outwardRegisterSave(metaDataSavePayload),
      circuitCreation({ itemId: id }, title, circuitPayload, true),
    ]);
  };

  const handleFinalSubmit = async () => {
    if (selectedDelivery !== undefined) {
      const ordArr = {
        ...orderRegister,
        dateRequestRaised: registerOldDate,
        dateOfDelivery: new Date(orderRegister.dateOfDelivery).toISOString(),
        dateOfReturn: new Date(orderRegister.dateOfReturn).toISOString(),
        orderRequest: true,
        isActive: true,
      };
      const ActArr = {
        ...selectedDelivery,
        asset_tracking_status: 'Order Registered',
      };

      const delArr = {
        ...ordArr,
        isActive: false,
        shipVia: 'test',
      };

      SetOrderRegister(DeliveryRequestInitialState);
      sendRespectiveEmail(
        'Notification',
        ActArr.title,
        'Created Outward Register',
        '',
        `${ActArr.type} is outward registered successfully on`,
      ); //email

      deleteOrderRegister(delArr.id);
      const id = selectedDelivery?.itemDeliveryRequest?.filter(
        (i) => i.isActive === true,
      )?.[0]?.id;
      const payload: OrderRegisterPayLoadType = {
        dateOfDelivery: orderRegister.dateOfDelivery,
        dateOfReturn: orderRegister.dateOfReturn,
        movementTo: orderRegister.movementTo,
        movementReason: orderRegister.movementReason,
        purpose: orderRegister.purpose,
        movementType: orderRegister.movementType,
        modeOfPayment: orderRegister.modeOfPayment,
        amount: orderRegister.amount,
      };
      const response = await DeliveryStore.OrderRegister(id, payload);
      if (commonStore.hfcCustomerChanges) {
        handleHFCSubmit(ActArr.id, ActArr.title);
      }
      setTimeout(async () => {
        await Promise.all([
          commonStore.updateHistoryAlonePOST(
            response,
            ActArr.id,
            undefined,
            true,
            true,
          ),
          listOrderRegister(),
        ]);
      }, 200);
      dashboardStore.dashboard.valueForL3Inventory = 'Approve';
    }
  };

  if (orderRegisterTrigger) return <LoadingComponent />;
  return (
    <Segment
      clearing
      style={{
        marginTop: '0.5em',
        padding: '10px',
        marginRight: '2.6em',
        height: '61.7vh',
        overflowY: 'auto',
      }}
      responsive={true}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content={
          (
            userLanguage[0].Level3InventoryDeliveryOrderRegister
              ?.IDORFL01 as any
          )?.[`${commonStore.language.key}`]
        } //'Film CAN Outward Request'
        sub
        color="grey"
      />
      <Header />
      <Header />

      <Form>
        <Form.Group fluid widths={2}>
          <Form.Field
            id="Work identifier"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL01 as any
              )?.[`${commonStore.language.key}`]
            } //'Work Identifier'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB01 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Work Identifier"
            value={orderRegister.itemGroupId}
          />
          <Form.Field
            id="Element"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            multiple
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL02 as any
              )?.[`${commonStore.language.key}`]
            } //'Item Id'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB02 as any
              )?.[`${commonStore.language.key}`]
            } //"Element"
            value={orderRegister.itemId}
          />
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            id="Element"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            //options={assetOptions}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL03 as any
              )?.[`${commonStore.language.key}`]
            } //'Element'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB03 as any
              )?.[`${commonStore.language.key}`]
            } //"Element"
            value={orderRegister.element}
          />
          <Form.Field
            id="totalCanCount"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL04 as any
              )?.[`${commonStore.language.key}`]
            } //'Number of film CANs'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB04 as any
              )?.[`${commonStore.language.key}`]
            } //" Enter Number of film CANs"
            value={orderRegister.numberOfElement}
          />
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            id="borrower_name"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL05 as any
              )?.[`${commonStore.language.key}`]
            } //'Borrower Name'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB05 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Borrower Name"
            value={orderRegister.borrowerName}
          />
          <Form.Field
            id="borrower_unique_code"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL06 as any
              )?.[`${commonStore.language.key}`]
            } //'Borrow Unique Code'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB06 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Borrow Unique Code"
            value={orderRegister.borrowerCode}
          />
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            id="borrower_address"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL07 as any
              )?.[`${commonStore.language.key}`]
            } //'Borrower Address'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB07 as any
              )?.[`${commonStore.language.key}`]
            } //"Enter Borrower Address"
            value={orderRegister.borrowerAddress}
          />
          <Form.Field
            id="borrower_phone"
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL08 as any
              )?.[`${commonStore.language.key}`]
            } //'Borrower Phone No'
            placeholder="" //{(userLanguage[0].Level3InventoryDeliveryOrderRegister?.IDORL01 as any)?.[`${commonStore.language.key}`]}
            value={orderRegister.borrowerPhoneNumber}
          />
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL09 as any
              )?.[`${commonStore.language.key}`]
            } //'Date of Request Raised '
            name="dateRequestRaised"
            placeholderText={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL09 as any
              )?.[`${commonStore.language.key}`]
            } //'Select Date'
            control={Input}
            value={orderRegister.dateRequestRaised}
          />
          <Form.Field
            control={Input}
            style={{ opacity: '0.7', pointerEvents: 'none' }}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL10 as any
              )?.[`${commonStore.language.key}`]
            } //'Borrower Email-Id'
            name="borrowerEmail"
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB10 as any
              )?.[`${commonStore.language.key}`]
            } //"Email Id"
            value={orderRegister.borrowerEmail}
          />
        </Form.Group>
        {/* editable area starts */}
        <hr
          style={{
            color: 'black',
            backgroundColor: 'black',
            height: '0.1px',
          }}
        />
        <Form.Group fluid widths="equal">
          <Form.Field required={true} error={deliveryDateError}>
            <label
            //Delivery Date
            >
              {
                (
                  userLanguage[0].Level3InventoryDeliveryOrderRegister
                    ?.IDORL11 as any
                )?.[`${commonStore.language.key}`]
              }
            </label>
            <Input
              placeholder="Date"
              name="dateOfDelivery"
              type="date"
              // defaultValue={''}
              min={new Date().toISOString().split('T')[0]}
              onChange={handleDateChange}
              value={orderRegister.dateOfDelivery}
            />
          </Form.Field>
          <Form.Field required={true} error={returnDateError}>
            <label
            //Return Date
            >
              {
                (
                  userLanguage[0].Level3InventoryDeliveryOrderRegister
                    ?.IDORL12 as any
                )?.[`${commonStore.language.key}`]
              }
            </label>
            <input
              placeholder="Date"
              name="dateOfReturn"
              type="date"
              defaultValue={''}
              onChange={handleDateChange}
              min={
                orderRegister.dateOfDelivery.length > 0
                  ? new Date(orderRegister.dateOfDelivery)
                      .toISOString()
                      .split('T')[0]
                  : new Date().toISOString().split('T')[0]
              }
              value={orderRegister.dateOfReturn}
              disabled={orderRegister.dateOfDelivery.length > 0 ? false : true}
            />
            {greaterDate.delivery && (
              <Label basic color="red" style={{ marginTop: '-13px' }}>
                Return date must be greater than delivery Date
              </Label>
            )}
          </Form.Field>
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            required={true}
            error={movementToError}
            name="movementTo"
            options={
              commonStore.hfcCustomerChanges ? hfcMovementTo : movementOptions
            }
            control={Select}
            search
            clearable
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL13 as any
              )?.[`${commonStore.language.key}`]
            } //'Movement To'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORDD01 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Movement To"
            value={orderRegister.movementTo}
            onChange={handleSelectChange}
          />
          {commonStore.hfcCustomerChanges && (
            <Form.Field
              control={TextArea}
              name="theatreAddress"
              label="Address"
              value={hfcInfo.address}
              disabled
            />
          )}
          <Form.Field
            required={true}
            error={movementReasonError}
            name="movementReason"
            options={movementReasonOptions}
            control={Select}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL14 as any
              )?.[`${commonStore.language.key}`]
            } //'Movement Reason '
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORDD02 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Movement Reason"
            value={orderRegister.movementReason}
            onChange={handleSelectChange}
          />
          <Form.Field
            required={true}
            error={purposeError}
            name="purpose"
            options={purposeOptions}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL15 as any
              )?.[`${commonStore.language.key}`]
            } //'Purpose'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB11 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Purpose"
            value={orderRegister.purpose}
          />
        </Form.Group>

        <Form.Group fluid widths="equal">
          <Form.Field
            required={true}
            error={movementTypeError}
            control={Select}
            options={movementTypeOptions}
            name="movementType"
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL16 as any
              )?.[`${commonStore.language.key}`]
            } //"Movement Type"
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORDD03 as any
              )?.[`${commonStore.language.key}`]
            } //'Movement Type'
            value={orderRegister.movementType}
            onChange={handleSelectChange}
          />
          {commonStore.hfcCustomerChanges && (
            <Form.Field
              control={Input}
              name="fedexAccount"
              label="Fedex Account"
              value={hfcInfo.fedexAccount}
              disabled
            />
          )}
          <Form.Field
            required={true}
            error={modeOfPaymentError}
            control={Select}
            name="modeOfPayment"
            options={paymentModeOptions}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL17 as any
              )?.[`${commonStore.language.key}`]
            } //'Mode of Payment'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORDD04 as any
              )?.[`${commonStore.language.key}`]
            } //"Select Mode of Payment"
            value={orderRegister.modeOfPayment}
            onChange={handleSelectChange}
          />
          <Form.Field
            required={true}
            error={amountError}
            name="amount"
            type={'number'}
            control={Input}
            label={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORL18 as any
              )?.[`${commonStore.language.key}`]
            } //'Amount'
            placeholder={
              (
                userLanguage[0].Level3InventoryDeliveryOrderRegister
                  ?.IDORTB12 as any
              )?.[`${commonStore.language.key}`]
            } //"Enter Amount"
            value={orderRegister.amount}
            onChange={handleDateChange}
          />
        </Form.Group>

        {commonStore.hfcCustomerChanges && (
          <>
            <hr
              style={{
                color: 'black',
                backgroundColor: 'black',
                height: '0.1px',
              }}
            />
            <h5 style={{ marginTop: '12px' }}>Play Date</h5>
            <Form.Group fluid widths="equal">
              <Form.Field required={true}>
                <label>From</label>
                <Input
                  placeholder="Date"
                  name="from"
                  type="date"
                  // defaultValue={''}
                  min={new Date().toISOString().split('T')[0]}
                  onChange={handleDateChange}
                  value={hfcDateInfo.from}
                />
              </Form.Field>
              <Form.Field required={true}>
                <label>To</label>
                <Input
                  placeholder="Date"
                  name="to"
                  type="date"
                  // defaultValue={''}
                  onChange={handleDateChange}
                  min={
                    hfcDateInfo.from.length > 0
                      ? new Date(hfcDateInfo.from).toISOString().split('T')[0]
                      : new Date().toISOString().split('T')[0]
                  }
                  value={hfcDateInfo.to}
                  disabled={hfcDateInfo.from.length > 0 ? false : true}
                />
                {greaterDate.play && (
                  <Label basic color="red">
                    To date must be greater than From Date
                  </Label>
                )}
              </Form.Field>
            </Form.Group>
          </>
        )}
      </Form>

      <Button.Group style={{ marginRight: '5px' }}>
        <Button onClick={() => SetOrderRegister(DeliveryRequestInitialState)}>
          {
            (
              userLanguage[0].Level3InventoryDeliveryOrderRegister
                ?.IDORB01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>

        <Button.Or
          text={
            (
              userLanguage[0].Level3InventoryDeliveryOrderRegister
                ?.IDORB02 as any
            )?.[`${commonStore.language.key}`]
          }
        />

        <Button
          //disabled={isSubmitting || !dirty}

          type="submit"
          content="Submit"
          onClick={handleSubmit}
          positive
          //Submit
        >
          {
            (
              userLanguage[0].Level3InventoryDeliveryOrderRegister
                ?.IDORB03 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>
      </Button.Group>
    </Segment>
  );
}

export default observer(OrderRegisterForm);
